export default "__VITE_ASSET__BCi79aHV__"